import { apiFileUpload, apiRequest } from "util/services";

export const WHATS_NEW_CMS_PATH = "/console/ops/whats-new-cms";

export function whatsNewDetailPath(id) {
  return `/console/whats-new/${encodeURIComponent(id)}`;
}

export function formatWhatsNewDate(iso, language = "en") {
  if (!iso) return "";
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return "";
  try {
    return new Intl.DateTimeFormat(language === "tr" ? "tr-TR" : "en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
    }).format(date);
  } catch {
    return iso.slice(0, 10);
  }
}

export function splitWhatsNewBody(body) {
  return String(body || "")
    .split(/\n{2,}/)
    .map((part) => part.trim())
    .filter(Boolean);
}

export async function fetchWhatsNewList(locale) {
  const result = await apiRequest(
    `whats-new?locale=${encodeURIComponent(locale || "en")}`,
    "GET"
  );
  return result?.success || { entries: [], unread_count: 0 };
}

export async function fetchWhatsNewEntry(id, locale) {
  const result = await apiRequest(
    `whats-new/${encodeURIComponent(id)}?locale=${encodeURIComponent(locale || "en")}`,
    "GET"
  );
  return result?.success || null;
}

export async function markWhatsNewRead(id, locale) {
  const result = await apiRequest(
    `whats-new/${encodeURIComponent(id)}/read?locale=${encodeURIComponent(locale || "en")}`,
    "POST"
  );
  return result?.success || null;
}

export async function markAllWhatsNewRead(locale) {
  const result = await apiRequest(
    `whats-new/read-all?locale=${encodeURIComponent(locale || "en")}`,
    "POST"
  );
  return result?.success || null;
}

export async function fetchWhatsNewAdminList() {
  const result = await apiRequest("whats-new/admin", "GET", null, true);
  if (!result || result.error) {
    return { error: result?.error || "FORBIDDEN", forbidden: true, entries: [] };
  }
  return { entries: result?.success?.entries || [] };
}

export async function saveWhatsNewEntry(payload, entryId) {
  const path = entryId
    ? `whats-new/admin/${encodeURIComponent(entryId)}`
    : "whats-new/admin";
  const method = entryId ? "PUT" : "POST";
  const result = await apiRequest(path, method, payload, true);
  if (result?.error) return { error: result.error };
  return { entry: result?.success };
}

export async function deleteWhatsNewEntry(entryId) {
  const result = await apiRequest(
    `whats-new/admin/${encodeURIComponent(entryId)}`,
    "DELETE",
    null,
    true
  );
  if (result?.error) return { error: result.error };
  return { ok: true };
}

export async function uploadWhatsNewImage(file) {
  const result = await apiFileUpload("whats-new/admin/upload", file);
  if (!result || result.error) {
    return { error: result?.error || "UPLOAD_FAILED" };
  }
  return { url: result.url };
}
